module.exports = __webpack_public_path__ + "a67d89028f37342faac7d0d9a7334a98.svg";